<template>
    <div class="mt-3">
        <b-button
            class="float-left"
            size="sm"
            @click="showShippingOptions"
            v-if="getShippingOptions.products === undefined || getShippingOptions.errors.length > 0"
            name="showShippingOptionsButton"
        >{{ $t('createShipment.button.showShippingOptions') }}</b-button>

        <div
            class="col-sm-12"
            style="padding-top: 10px; padding-bottom: 10px;"
            name="noShippingOptionsMessage"
            v-if="
                    getShippingOptions.products !== undefined &&
                        getShippingOptions.products.length == 0 &&
                        getShippingOptions.quoteProducts !== undefined &&
                        getShippingOptions.quoteProducts.length == 0
                "
        >
            <h3>{{ $t('createShipment.errors.noproductsfound') }}</h3>
        </div>

        <shippingOptionsCards
            v-if="!display(fieldNames.SHOW_LEGACY_SHIPPING_OPTIONS)"
            @create-shipment="createShipment"
            @create-prebooking="createPreBooking"
            @display-request-quote="displayRequestQuote"
            @show-alternatives="displayAlternatives"
            @show-aes="showAes"
            :products="fetchedProducts"
            :get-shipment-price="getShipmentPrice"
        ></shippingOptionsCards>

        <div
            v-if="getShippingOptions.products !== undefined && getShippingOptions.products.length > 0 && !display(fieldNames.SHOW_LEGACY_SHIPPING_OPTIONS)"
            class="float-left"
        >{{ $t('createShipment.info.transitTime') }}</div>

        <shippingOptionsTable
            v-if="display(fieldNames.SHOW_LEGACY_SHIPPING_OPTIONS)"
            @create-shipment="createShipment"
            @create-prebooking="createPreBooking"
            @display-request-quote="displayRequestQuote"
            :v="v"
            :get-shipment-price="getShipmentPrice"
        ></shippingOptionsTable>

        <requestQuoteModal
            ref="requestQuoteModal"
            @confirmAction="requestQuote"
        />

        <aesModal
            :v="v"
            :totalWeight="shipment.colliDetails.totalWeight"
            :colliCount="shipment.colliDetails.numberOfColli"
            :customsAmount="shipment.customsAmount"
            @add-aes-line="addAesLine"
            @remove-aes-line="removeAesLine"
            @create-shipment="createShipment"
            ref="aesModal"
        />

        <alternativeProductsModal
            ref="alternativeProductsModal"
            @create-shipment="createShipment"
            @create-prebooking="createPreBooking"
            :get-shipment-price="getShipmentPrice"
        />

        <b-modal
            ref="pre-booking-modal"
            id="pre-booking-modal"
            :title="$t('createShipment.modals.preBookingTitle')"
            @ok="reloadPage"
            okOnly
            name="preBookingModal"
        ></b-modal>

        <b-modal
            ref="error-booking-modal"
            id="error-booking-modal"
            :title="$t('createShipment.modals.errorBookingTitle')"
            @ok="reloadPage"
            okOnly
            name="errorBookingModal"
        ></b-modal>

        <b-modal
            ref="error-booking-not-received-modal"
            id="error-booking-not-received-modal"
            :title="$t('createShipment.modals.errorBookingNotReceivedTitle')"
            okOnly
            name="errorBookingNotReceivedModal"
        >
            <p>{{ $t('createShipment.modals.errorBookingNotReceivedBody') }}</p>
        </b-modal>
    </div>
</template>
<script>
  import { EventBus } from '@/services/event-bus.js';
  import { ACTIONS, MUTATIONS, CREATE_SHIPMENT_PREFIX, CORE_PREFIX } from '../store/constants';
  import { mapState, mapGetters } from 'vuex';
  import vSelect from './vSelect';
  import 'vue-select/dist/vue-select.css';
  import helpers from '../helper';
  import viewOptions from '../mixins/viewOptionsMixin';
  import localization from '../mixins/localizationMixin';
  import validationSummary from '../mixins/validationSummary';
  import { FIELD_NAMES, EVENTS, BOOKING_TYPES } from '../store/nameConstants';
  import servicePrice from './servicePrice';
  import quoteProductRow from './quoteProduct';
  import shippingOptionsCards from './shippingOptionsCards';
  import shippingOptionsTable from './shippingOptionsTable';
  import requestQuoteModal from './requestQuoteModal';
  import alternativeProductsModal from './alternativeProductsModal';
  import aesModal from './AES/aesModal';
  import {authService} from "@/msal";

  export default {
      props: {
          shipment: { type: Object, required: true },
          v: { required: true },
          files: {type: Array},
          invoice: {type: Object},
          invoiceRequired: {type: Boolean},
          hasValidationErrors: false
      },
      components: {
          vSelect,
          servicePrice,
          quoteProductRow,
          shippingOptionsCards,
          shippingOptionsTable,
          requestQuoteModal,
          alternativeProductsModal,
          aesModal,
      },
      mixins: [viewOptions, localization, validationSummary],
      watch: {
          'shipment.shipDate': {
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
      },
      data() {
          return {
              servicePoint: null,
              fieldNames: FIELD_NAMES,
              products: [],
              quoteProducts: [],
              selectedProduct: null,
              selectedService: null,
              currentPriceLine: null,
              errorBookingListenerAdded: false,
              errorBookingPending: false,
              validationErrorPending: false,
              productChange: new Date(),
              
          };
      },

      created() {
          this.addValidationErrorListener();
      },

      beforeDestroy() {
          EventBus.$emit('remove-validation-error-handler');
          EventBus.$emit('remove-error-booking-handler');
      },

      methods: {
          displayAlternatives(item) {
              this.$refs['alternativeProductsModal'].show(item);
          },
          displayRequestQuote(quoteProduct) {
              this.$refs['requestQuoteModal'].show(quoteProduct);
          },
          requestQuote(data) {
              this.$store.dispatch(CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.REQUEST_QUOTE, {
                  quoteProduct: data.quoteProduct,
                  shipment: this.shipment,
                  sendRequestTo: data.userEmail,
                  shippingProducts: this.getShippingOptions.products,
              });

              data.quoteProduct.quoteRequested = true;
          },

          addBookingErrorListener() {
              this.errorBookingListenerAdded = true;
              let self = this;

              let handler = (e) => {
                  if (e.ctrlKey && e.keyCode == 81) {
                      //CTRL + Q
                      if (!self.errorBookingPending) {
                          //Add flag to avoid multiple calls being made from ctrl+q combination
                          self.errorBookingPending = true;

                          if (self.selectedProduct !== null && self.getBackendErrors.length > 0) {
                              self.shipment.bookingType = BOOKING_TYPES.ERROR_BOOKING;
                              self.createShipment(self.selectedProduct);
                          } else {
                              this.$refs['error-booking-not-received-modal'].show();
                              self.errorBookingPending = false;
                          }
                      }
                  }
              };

              window.addEventListener('keydown', handler);

              EventBus.$on('remove-error-booking-handler', () => {
                  window.removeEventListener('keydown', handler);
              });
          },

          addValidationErrorListener() {
              let self = this;

              let handler = (e) => {
                  //CTRL + 0
                  if (e.ctrlKey && e.keyCode == 48) {
                      if (!self.validationErrorPending) {
                          //Add flag to avoid multiple calls being made from ctrl+0 combination
                          self.validationErrorPending = true;

                          console.log('Shipment: ', this.shipment); //Dont remove
                          console.log('Validation: ', this.v); //Dont remove

                          self.validationErrorPending = false;
                      }
                  }
              };

              window.addEventListener('keydown', handler);

              EventBus.$on('remove-validation-error-handler', () => {
                  window.removeEventListener('keydown', handler);
              });
          },

          async showShippingOptions() {
              if (!this.errorBookingListenerAdded) {
                  this.addBookingErrorListener();
              }
              this.products = [];
              this.selectedProduct = null;
              this.v.$touch();

              if (this.v.shipment.$anyError) {
                  let validationErrors = this.$allErrors;

                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_BACKENDERROR,
                      {
                          localizedMessage: 'Please correct validation errors: ',
                          validationErrors: validationErrors,
                      }
                  );

                  return;
              }
              
              if (this.$route.query.AWB !== undefined){
                  this.shipment.action = "RegisterSaveShipment";
              }

              await this.$store.dispatch(
                  CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_SHIPPING_OPTIONS,
                  JSON.parse(JSON.stringify(this.shipment))
              );

              window.scrollBy(0, 800);
          },

          createPreBooking(selectedProduct) {
              this.shipment.bookingType = BOOKING_TYPES.PRE_BOOKING;
              this.createShipment(selectedProduct);
          },

          handleBookingResponse() {
              //If there are no errors
              if (this.getBackendErrors.length === 0) {
                  //Final booking
                  if (this.shipment.bookingType === BOOKING_TYPES.FINAL_BOOKING) {
                      this.$router.push({ name: 'displayLabel' });
                  }

                  //Show error booking modal
                  if (this.shipment.bookingType === BOOKING_TYPES.ERROR_BOOKING) {
                      this.$refs['error-booking-modal'].show();
                      this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
                  }

                  //Show pre booking modal
                  if (this.shipment.bookingType === BOOKING_TYPES.PRE_BOOKING) {
                      this.$refs['pre-booking-modal'].show();
                      this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
                  }
              }

              //If there are any errors
              else {
                  this.$refs['alternativeProductsModal'].hide(true);
                  this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);

                  window.scrollTo(0, 0);
              }
          },

          reloadPage() {
              window.location.reload();
          },

          async getShipmentPrice(selectedProduct) {
              this.selectedProduct = selectedProduct;

              let payload = {
                  shipment: JSON.parse(JSON.stringify(this.shipment)),
                  selectedProduct: JSON.parse(JSON.stringify(selectedProduct)),
              };

              let priceLines = this.$store.dispatch(
                  CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.GET_SHIPMENT_PRICE,
                  payload
              );
              return priceLines;
          },

          addAesLine() {
              this.shipment.customsAmount.commodities.push({
                  description: '',
                  countryOfManufacture: 'US',
                  harmonizedCode: '',
                  quantity: 1,
                  unitWeight: 0,
                  unitPrice: {
                      amount: 0,
                      currencyCode: this.shipment.customsAmount.currencyCode,
                  },
              });
          },

          removeAesLine(index) {
              this.shipment.customsAmount.commodities.splice(index, 1);
          },

          showAes(selectedProduct) {
              this.$refs['aesModal'].show(selectedProduct);
          },

          async createShipment(selectedProduct) {
            if(selectedProduct.prebooking && this.shipment.bookingType !== BOOKING_TYPES.PRE_BOOKING) {
              this.$store.dispatch(
                  CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_BACKENDERROR,
                  {
                    localizedMessage: 'Please wait a couple of seconds and try again',
                    validationErrors: null,
                  }
              );
              window.scrollTo(0, 0);
              return;
            }
            
            selectedProduct.selected = true;
              
              this.selectedProduct = selectedProduct;

              this.v.$touch();
              if (this.v.shipment.$anyError) {
                  let validationErrors = this.$allErrors;
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_BACKENDERROR,
                      {
                          localizedMessage: 'Please correct validation errors: ',
                          validationErrors: validationErrors,
                      }
                  );

                  this.$refs['alternativeProductsModal'].hide(true);

                  window.scrollTo(0, 0);

                  return;
              }
              
              if (this.invoiceRequired && (this.invoice == null && this.files.length === 0) && this.shipment.bookingType !== BOOKING_TYPES.PRE_BOOKING){
                this.$store.dispatch(
                    CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_BACKENDERROR,
                    {
                      localizedMessage: 'Please upload or create invoice',
                      validationErrors: null,
                    }
                );

                this.$refs['alternativeProductsModal'].hide(true);

                window.scrollTo(0, 0);

                return
              }

              this.shipment.alternativeTransportProductUsed = selectedProduct.alternativeBooking;

              this.shipment.priceLines = selectedProduct.priceLines;

              var payload = {
                  shipment: JSON.parse(JSON.stringify(this.shipment)),
                  selectedProduct: JSON.parse(JSON.stringify(selectedProduct)),
                  saveFlags: JSON.parse(JSON.stringify(this.shipment.saveFlags)),
                  files: JSON.parse(JSON.stringify(this.files)),
                  invoice: JSON.parse(JSON.stringify(this.invoice))
              };
              //Clear Not needed Data      
              payload.shipment.priceLines = null;
              payload.selectedProduct.priceLines = null

              if (this.shipment.bookingType === BOOKING_TYPES.ERROR_BOOKING) {
                  payload.errorMessage = this.getBackendErrors[0].message;
              }

              if (this.$route.query.id !== undefined) {
                  payload.shipmentId = this.$route.query.id;
                  payload.copy = this.$route.query.copy;
                  if (this.$route.query.shotFileShipment === 'true') {
                      payload.copy = this.$route.query.shotFileShipment;
                  }
              }
            
              let awb = this.$route.query.AWB;
              if (awb !== undefined){
                  payload.awb = awb;
              }
              
              let response = await this.$store.dispatch(
                  CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CREATE_SHIPMENT,
                  payload
              );

              if (response !== undefined && response.data.isAES === true) {
                  this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);

                  this.$refs['aesModal'].show(selectedProduct);
              } else {
                  this.handleBookingResponse();

                  //Reset booking
                  this.errorBookingPending = false;
                  this.shipment.bookingType = BOOKING_TYPES.FINAL_BOOKING;
              }
          },
      },
      computed: {
          ...mapGetters('createShipment', [
              'getShippingOptions',
              'getBackendErrors',
              'getServicePrices',
          ]),

          fetchedProducts() {
              if (this.productChange) {
                  if (this.getShippingOptions.products) {
                      this.products = helpers.cloneObject(this.getShippingOptions.products);
                  }
              }

              if (this.products && this.products.length > 0) {
                  if (
                      this.getShippingOptions.quoteProducts &&
                      this.getShippingOptions.quoteProducts.length > 0
                  ) {
                      this.getShippingOptions.quoteProducts.forEach((quoteProduct) => {
                          this.products.push(quoteProduct);
                      });
                  }

                  return _.chunk(Object.values(this.products), 5);
              }

              return this.products;
          },
      },
  };
</script>

<style>
  .headers {
      font-weight: bold;
      padding: 12px;
      border: solid 1px #1f7037;
      background: #1f7037;
      color: #eeeeee;
  }

  .borders div {
      border-right: solid 1px #1f7037;
      border-bottom: solid 1px #1f7037;
      padding: 4px;
  }

  .create-shipment-buttons {
      padding-top: 15px;
      float: left;
  }

  #leftBorder {
      border-left: solid 1px #1f7037;
  }

  #services {
      padding-left: 25px;
  }

  #servicePoints {
      background: none;
      border: 1px solid rgba(60, 60, 60, 0.26);
      border-radius: 4px;
      white-space: normal;
      padding: 0px;
  }

  .price-accordion-total-price {
      float: left;
      cursor: pointer !important;
  }

  .price-accordion {
      float: left;
      text-align: left;
      padding: 0px;
  }

  .price-expanded {
      margin-bottom: 0px;
  }

  .borders div > div {
      border: 0;
  }

  .service-point-dropdown div div span {
      width: 150px !important;
      height: 18px !important;
      overflow: hidden;
      white-space: nowrap;
  }

  .service-point-dropdown ul li {
      overflow: hidden;
      white-space: no wrap;
  }

  .service-point-dropdown ul {
      width: 400px !important;
  }
</style>
